import _dottedPathToPopulation from '@/shared/functions/population-helpers/_dottedPathToPopulation';

/**
 * Generate standard tire size population object for the given prefix
 *
 * @param path - The path to generate the population object for
 * @returns The population object
 *
 * @example
 * // Returns {
 * //   'populate[tireSize][tire][brand]': 1,
 * //   'populate[tireSize][tire][certifiedBy]': 1,
 * //   'populate[tireSize][tire][euTireLabel]': 1,
 * //   'populate[tireSize][tireDot]': 1,
 * //   'populate[tireSize][tireDot][specialPrice]': 1,
 * // }
 * standardTireSizePopulation('tireSize.tire')
 */
export default function standardTireDotPopulation(
  path: string = '',
  {
    populateRoot = true,
  }: {
    /**
     * Whether to populate the current TireDot object itself
     */
    populateRoot?: boolean;
  } = {}
) {
  const p = _dottedPathToPopulation(path);

  return {
    ...(populateRoot ? { [`populate${p}`]: 1 } : {}),
    [`populate${p}[specialPrice]`]: 1,
  };
}
